var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}]},[_c('core-toolbar'),_c('router-view'),_c('core-footer',{attrs:{"id":"cfooter"}}),_c('btn-fixed',[_vm._v("Schedule a consultation")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }